/**
 * Extracts the value from an autocomplete object if present, otherwise returns the original value.
 * 
 * @param value - The value to check, could be an autocomplete object or a direct value
 * @returns The extracted value or empty string if value is falsy
 */
export const getAutocompleteValue = (value: any): string => {
  if (value && typeof value === 'object' && 'value' in value) {
    return value.value;
  }
  return value || '';
};
